"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const class_transformer_1 = require("class-transformer");
const CustomAsync_1 = __importDefault(require("../decorators/CustomAsync"));
const Di_1 = __importDefault(require("../injectables/Di"));
const EPaymentMethod_1 = require("../../enums/ProductSubscribed/EPaymentMethod");
const ESubscriptionProductType_1 = require("../../enums/ProductSubscribed/ESubscriptionProductType");
const EDemembrementType_1 = require("../../enums/ProductSubscribed/EDemembrementType");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
class ProductSubscriptionCorporationCreateResource extends Resource_1.default {
}
exports.default = ProductSubscriptionCorporationCreateResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    (0, CustomAsync_1.default)((id) => Di_1.default.getProductService().productSheetExists(id), {
        message: ValidationErrors_1.EValidationError.productNotExists,
    }),
    __metadata("design:type", String)
], ProductSubscriptionCorporationCreateResource.prototype, "productSheetId", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    (0, CustomAsync_1.default)((id) => Di_1.default.getCorporationService().corporationSheetExists(id), {
        message: ValidationErrors_1.EValidationError.corporationNotExists,
    }),
    __metadata("design:type", String)
], ProductSubscriptionCorporationCreateResource.prototype, "corporationSubscriberId", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ProductSubscriptionCorporationCreateResource.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(EPaymentMethod_1.EPaymentMethod),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSubscriptionCorporationCreateResource.prototype, "paymentMethod", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ESubscriptionProductType_1.ESubscriptionProductType),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSubscriptionCorporationCreateResource.prototype, "subscriptionProductType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ProductSubscriptionCorporationCreateResource.prototype, "demembrementDuration", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(EDemembrementType_1.EDemembrementType),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSubscriptionCorporationCreateResource.prototype, "demembrementType", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.demembrementType === EDemembrementType_1.EDemembrementType.viager && o.subscriptionProductType !== ESubscriptionProductType_1.ESubscriptionProductType.pleine_propriete),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(150),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ProductSubscriptionCorporationCreateResource.prototype, "viagerAge", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSubscriptionCorporationCreateResource.prototype, "contrepartieNom", void 0);
